import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AddprestartPage } from './addprestart';

@NgModule({
  declarations: [
    AddprestartPage,
  ],
  imports: [
    IonicPageModule.forChild(AddprestartPage),
  ],
})
export class AddprestartPageModule {}



// WEBPACK FOOTER //
// ./src/pages/addprestart/addprestart.module.ts